import { PermissionType } from 'enums/permissionType.enum';
import { IHeaderMenuItem } from 'components/AppHeader/types';
import { PageURL } from 'router/pageURL';

const allUsers = Object.values(PermissionType);

export const calculatorHeaderTabs: IHeaderMenuItem[] = [
  {
    textId: 'menu.calculator',
    link: PageURL.CALCULATOR,
    permissions: [...allUsers],
  },
  {
    textId: 'menu.criteria',
    link: PageURL.CRITERIA,
    permissions: [...allUsers],
    isNewTab: true,
  },
  {
    textId: 'menu.resourceHub',
    link: PageURL.RESOURCE_HUB,
    permissions: [...allUsers],
    isNewTab: true,
  },
];
